import React from "react";
import { FaBoxOpen, FaShoppingBag, FaUsers } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import "./admin.css";

function Admin() {
  const navigate = useNavigate();

  return (
    <div className="admin-container">
      <h2 className="admin-title">Admin Dashboard</h2>

      <div className="admin-cards">
        <div
          className="admin-card"
          onClick={() => navigate("/admin/listings")}
        >
          <FaBoxOpen size={40} />
          <span>Products</span>
        </div>

        <div
          className="admin-card"
          onClick={() => navigate("/admin/orders")}
        >
          <FaShoppingBag size={40} />
          <span>Orders</span>
        </div>

        {/* ✅ NEW CUSTOMER CARD */}
        <div
          className="admin-card"
          onClick={() => navigate("/admin/customer")}
        >
          <FaUsers size={40} />
          <span>Customers</span>
        </div>
      </div>
    </div>
  );
}

export default Admin;
